import { Injectable } from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { ConfigurationService } from 'src/app/shared/services/configuration.service';
import { AppUrls } from 'src/app/shared/app-urls';
import { UserMainMenuItemsAdapter } from '../adapters/user-main-menu-item-adapter';
import { UserMainMenuItem } from '../interfaces/user-main-menu-item.interface';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UnprocessedClarification } from '../interfaces/unprocessed-clarification.interface';
import { RegulationsAcceptResponse } from '../interfaces/regulations-accept-response.interface';

@Injectable({
  providedIn: 'root',
})
export class MainMenuService {
  private _httpBackend: HttpClient;

  constructor(
    private _http: HttpClient,
    private _configurationService: ConfigurationService,
    private _backend: HttpBackend
  ) {
    this._httpBackend = new HttpClient(this._backend);
  }

  public getUserMenu(): Observable<MenuItem[]> {
    return this._http
      .get<UserMainMenuItem[]>(AppUrls.mainMenu.getMenu)
      .pipe(map((items) => UserMainMenuItemsAdapter.adapt(items)));
  }

  public getProtocolFilterCounter(url: string): Observable<number> {
    return this._http.get<number>(url);
  }

  public getFavoriteTradesCount(baseUrl: string): Observable<number> {
    const url = `${baseUrl}${AppUrls.mainMenu.getFavoriteTradesCount}`;
    return this._http.get<number>(url);
  }

  public getToDayEvents(baseUrl: string): Observable<number> {
    const url = `${baseUrl}${AppUrls.mainMenu.getCalendarEventsCount}`;
    return this._http.get<number>(url);
  }

  public getUnprocessedClarificationRequests(
    baseUrl: string
  ): Observable<UnprocessedClarification> {
    const url = `${baseUrl}${AppUrls.mainMenu.getClarificationRequestsCount}`;
    return this._http.get<UnprocessedClarification>(url);
  }

  public getUnprocessedResultClarification(baseUrl: string): Observable<UnprocessedClarification> {
    const url = `${baseUrl}${AppUrls.mainMenu.getResultClarificationCount}`;
    return this._http.get<UnprocessedClarification>(url);
  }

  public setRegulationsAccept(): Observable<RegulationsAcceptResponse> {
    const absoluteUrl = `${this._configurationService.configuration.links.fcsBaseUrl}${AppUrls.mainMenu.regulationsAccept}`;
    return this._httpBackend.post<RegulationsAcceptResponse>(absoluteUrl, null, {
      withCredentials: true,
    });
  }
}
